WiseMetering.Views.NewSite = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/zones/new_site',
    className: 'mbx-info text-left',
    form_prefix: 'zone',
    title: () => i18next.t('modal.title.sites.new'),
    input_readers: [{
        type: 'default',
        func: function(el) {
            return el.val() === '' ? null : el.val();
        }
    }],
    width: '75%',
    map: null,
    marker: null,
    defaultZoom: 2,

    ui: {
        categoryId: 'select#zone_category_id',
        imagePreviewImage: '.preview-site-image'
    },

    events: {
        'change .input-image': 'onChangeImage',
        'keyup #address': 'search'
    },

    getFormData: function() {
        const
            data = this.formSerializer(),
            tag_ids = [];

        // == null caught both null and undefined; keep that exact behaviour
        // (formSerializer can produce either) now that eqeqeq bans it.
        if (data.description === null || data.description === undefined) {
            delete data['description'];
        }
        if (this.imageFile) {
            data.image = this.imageFile;
        }
        if (this.removeImage) {
            data.image = '';
        }
        Object.entries(data.tag_ids).forEach(([key, value]) => {
            if (value) {
                tag_ids.push(key);
            }
        });
        data.tag_ids = tag_ids;
        data.type = 'site';
        return data;
    },

    serializeData: function() {
        return Object.assign(
            {
                address: {
                    street: ''
                }
            },
            this.model.toJSON()
        );
    },

    onChangeImage: function(event) {
        const [file] = event.target.files;
        if (file) {
            this.ui.imagePreviewImage.attr('src', URL.createObjectURL(file));
            this.imageFile = file;
        }
    },

    onRender: function() {
        this.$('select#zone_category_id').append(
            WiseMetering.utils.optionsFromModels(
                WiseMetering.zoneCategories.where({ site: true }),
                'name',
                this.model.get('category_id')
            )
        );
    },

    onShow: function() {
        this.mapOptions = {
            zoom: this.defaultZoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: { mapTypeIds: [] }
        };
        const center = new google.maps.LatLng(39.980205, -7.905591);
        this.createMap(center);
    },

    createMap: function(center) {
        this.map = new google.maps.Map(document.getElementById('map_canvas'), this.mapOptions);
        google.maps.event.addListener(this.map, 'zoom_changed', function() {
            this.mapOptions.zoom = this.map.getZoom();
        }.bind(this));

        this.map.setCenter(center);
        this.marker = new google.maps.Marker({
            map: this.map,
            position: center,
            draggable: true
        });

        this.setLatLng(this.marker.getPosition());
        google.maps.event.addListener(this.marker, 'dragend', function() {
            center = this.marker.getPosition();
            this.map.setCenter(center);
            this.setLatLng(center);
        }.bind(this));
    },

    setLatLng: function(position) {
        this.$('input#zone_latitude').val(position.lat());
        this.$('input#zone_longitude').val(position.lng());
    },

    codeAddress: function() {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': document.getElementById('address').value }, function(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                if (this.mapOptions.zoom === this.defaultZoom) {
                    this.mapOptions.zoom = 15;
                }
                this.createMap(results[0].geometry.location);
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        }.bind(this));
    },

    search: function(event) {
        if ((event.keyCode || event.which) === 13) {
            event.stopPropagation();
            event.preventDefault();
            this.codeAddress();
        }
    },

    submitData: function(data) {
        const formData = new FormData();

        Object.entries(data).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                if (value.length > 0) {
                    value.forEach(item => formData.append(`${key}[]`, item));
                } else {
                    formData.append(`${key}[]`, []);
                }
            } else {
                if (value !== null && value !== undefined) {
                    formData.append(key, value);
                }
            }
        });

        // https://stopbyte.com/t/how-to-send-multipart-formdata-with-jquery-and-ajax/58/2
        return $.ajax({
            contentType: false,
            data: formData,
            processData: false,
            type: 'POST',
            url: this.model.urlRoot
        });
    },

    afterSave: function() {
        WiseMetering.indicators.fetch().then(() => WiseMetering.folders.fetch());
    }
});
